var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconXSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.41,12l4.3,4.29-1.42,1.42L12,13.41l-4.29,4.3L6.29,16.29,10.59,12,6.29,7.71,7.71,6.29,12,10.59l4.29-4.3,1.42,1.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXSmall);
export default __webpack_public_path__ + "static/1768397567/media/icon-x-small.785e6b4f3b2fd8159e9ccf5145b7b5ce.svg";
export { ForwardRef as ReactComponent };